<template>
  <div id="intergralRecord">
    <div class="rightHead">
      <div
        style="margin:0 0 0 30px;font-size:15px;padding-top:16px;color:#707070;"
        v-if="$route.meta.titleShow"
      >
        {{ $route.name }}
      </div>
    </div>
    <div class="invoicingHead" style="height: 40px">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>积分记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="searchGroup">
      <div class="row">
        <span class="phone">手机号</span>
        <el-input
          placeholder="请输入手机号"
          v-model="phoneNum"
          style="width:220px;margin-right:20px;"
          @blur="phoneNumBlur"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
      <div class="table-content">
        <el-table
          :data="tableData"
          style="width: 100%"
          v-loading="loading"
          element-loading-background="rgba(0, 0, 0, 0.3)"
          element-loading-text="数据正在加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column
            align="center"
            prop="shopMemberId"
            label="会员卡ID"
          />
          <el-table-column align="center" prop="phoneNum" label="手机号" />
          <el-table-column align="center" prop="userScore" label="积分值" />
          <el-table-column align="center" prop="remark" label="备注" />
          <el-table-column align="center" prop="modifyTime" label="修改时间" />
        </el-table>
        <div
          v-if="tableData.length > 0"
          class="block"
          style="float:right;margin-top:10px;"
        >
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNo"
            :page-size="queryInfo.row"
            layout="total, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCardScoreList } from "../api/index";
export default {
  data() {
    return {
      phoneNum: "",
      tableData: [],
      loading: false,
      queryInfo: {
        pageNo: 1,
        row: 10
      },
      total: 0,
      status: "",
      userList: {}
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    this.getCardScoreList();
  },
  methods: {
    getCardScoreList(phoneNum) {
      this.loading = true;
      getCardScoreList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        pageNumber: this.queryInfo.pageNo,
        row: this.queryInfo.row,
        phoneNum: phoneNum
      }).then(res => {
        this.loading = false;
        if (res.code == 1) {
          this.tableData = res.data.list;
          this.total = res.data.totalCount;
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      if (this.status == 1) {
        this.getCardScoreList(this.phoneNum);
      } else {
        this.getCardScoreList();
      }
    },
    search() {
      this.status = 1;
      this.queryInfo.pageNo = 1;
      this.getCardScoreList(this.phoneNum);
    },
    phoneNumBlur() {
      if (!this.phoneNum) {
        this.getCardScoreList();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#intergralRecord {
  width: calc(100vw - 217px);
  height: calc(100vh);
  margin-left: 200px;
  min-width: 1340px;
  .searchGroup {
    width: 100%;
    padding-top: 120px;
    padding-left: 20px;
    box-sizing: border-box;
    .row {
      .phone {
        padding: 8px 10px 0 0;
      }
    }
    .table-content {
      width: calc(100vw - 280px);
      padding-top: 40px;
      box-sizing: border-box;
    }
  }
}
::v-deep .el-table th {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/page/intergralRecord.vue